<template>
  <div class="sms-box">
    <div class="sms-box-title">短信验证</div>
    <van-cell-group inset class="login-form" ref="ref_header_form">
      <div class="form-item">
        <div class="item-icon item-icon-phone"></div>
        <van-field class="login-input" ref="ref_login_user" v-model="phone" disabled clearable placeholder="手机号"></van-field>
      </div>
      <!-- 密码 -->
      <div class="form-item">
        <div class="item-icon item-icon-verify"></div>
        <van-field class="login-input" ref="ref_login_pwd" v-model="loginForm.checkVerification" clearable placeholder="请输入验证码">
          <template slot="right-icon">
            <van-button class="verify-btn" @click="sendCaptchaCode">{{ sms.text }}</van-button>
          </template>
        </van-field>
      </div>
      <div class="errorStyle">
        <div class="errorStyle-text" style="color: red" v-show="err_message">{{ err_message }}</div>
        <div class="errorStyle-text" v-show="!err_message">
          {{ warn_message ? warn_message : '请输入验证码进行登录' }}
        </div>
      </div>
      <!-- 登录按钮 -->
      <van-button plain type="info" @click="handleLogin" class="form-item login-btn login-btn-dl">登录</van-button>
    </van-cell-group>
  </div>
</template>
<script>
import { encryptedData } from '../../utils/JSEncrypt';
import { setToken } from '../../utils/auth';
import { asyncRoutes } from '@/router';
import { matchMobileVerify, beSendMobileMessage } from '@/api/baseMsg';
import { Toast } from 'vant';
export default {
  name: 'sms',
  props: {
    userName: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: ''
    }
  },
  components: {},
  computed: {},
  data() {
    return {
      loginForm: {
        username: '',
        phone: '',
        checkVerification: '',
        uuid: ''
      },
      sms: {
        digits: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
        visible: false,
        text: '获取验证码',
        errMsg: '',
        btnDisabled: false,
        times: null,
        repeatTimeOut: '', //短信剩余时间
        timeOut: 0,
        form: {
          captchaCode: ''
        },
        phoneNum: '',
        withMatchCode: ''
      },
      warn_message: '',
      err_message: ''
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 点击-发送验证码
    sendCaptchaCode() {
      if (this.sms.repeatTimeOut != '') {
        const date1 = new Date(this.sms.repeatTimeOut);
        const date2 = new Date();
        if (date1.getTime() > date2.getTime()) {
          this.err_message = `短信验证码已发送，${this.sms.digits[this.sms.timeOut]}分钟内不得重复点击`;
          return false;
        }
      }
      this.err_message = '';
      const params = {
        // userName: encryptedData(this.loginForm.username.trim())
        userName: encryptedData(this.userName.trim())
      };
      beSendMobileMessage(params).then((res) => {
        if (res.code == 200 && res.success == true) {
          this.error_message = res.message;
          this.sms.repeatTimeOut = '';
          this.warn_message = res.message;
          this.sms.withMatchCode = res.withMatchCode;
          this.sms.timeOut = res.duplicateSendingTimeIsNotAllowed;
          this.smsCountDown(this.sms.timeOut);
        } else if (res.success == false) {
          this.sms.errMsg = '';
          this.sms.repeatTimeOut = res.repeatTimeOut;
          this.sms.withMatchCode = res.withMatchCode;
          this.sms.timeOut = res.duplicateSendingTimeIsNotAllowed;
        }
      });
    },
    // 验证码倒计时
    smsCountDown(time) {
      this.sms.withMatchCode = '';
      this.sms.text = time * 60 + '秒后重新获取验证码';
      this.sms.btnDisabled = true;
      this.sms.times = setInterval(() => {
        let second = parseInt(this.sms.text);
        second--;
        if (second == -1) {
          this.sms.text = '重新获取验证码';
          this.sms.btnDisabled = false;
          clearInterval(this.sms.times);
          this.sms.times = null;
        } else {
          this.sms.text = second + '秒后重新获取验证码';
        }
      }, 1000);
    },
    // 点击登录
    handleLogin() {
      console.log('00', 0);
      const _this = this;
      if (!this.phone) {
        return isClickP();
      }
      if (!this.loginForm.checkVerification) {
        return isClickV();
      }
      Toast.loading({
        message: '登录中...',
        duration: 0, // 持续展示 toast
        loadingType: 'spinner',
        className: 'toast'
      });
      matchMobileVerify({ userName: encryptedData(this.userName.trim()), verificationCode: this.loginForm.checkVerification }).then((res) => {
        if (res.code === 200 && res.success) {
          setToken(res.data.token);
          this.$store.commit('login/SET_LOGINUSERFORM', this.userName);
          this.$store.commit('login/SET_LOGINTYPE', this.type);
          this.$store.commit('SET_NAME', this.userName);

          this.$store.dispatch('getListTreeFuns').then((res1) => {
            const data = res1.data;
            this.$store.dispatch('permissionFuns/generateRoutes', data).then((res2) => {
              res2.forEach((i) => {
                asyncRoutes.push(i);
              });
              const resultRouter = asyncRoutes;
              this.$router.addRoutes(resultRouter);
              if (res.data.user.ifSystem == 1) {
                this.$router.push({ path: '/' });
              } else {
                this.$router.push({ path: '/jiagecaijiTB/jiagecaiji' });
              }
            });
          });
        } else {
          this.err_message = res.message || '登录失败';
          this.loginForm.password = '';
          this.loginForm.checkVerification = '';
          this.loginForm.passwordEncry = '';
          this.loginForm.usernameEncry = '';
          this.loginForm.uuid = '';
        }
        Toast.clear();
      });

      function isClickP() {
        let result = true;
        if (!_this.phone) {
          result = false;
          _this.err_message = '手机号为空，请联系管理员！';
        } else {
          result = true;
          _this.err_message = '';
        }
        return result;
      }
      function isClickV() {
        let result = true;
        if (!_this.loginForm.checkVerification) {
          result = false;
          _this.err_message = '请输入验证码，进行登录！';
        } else {
          result = true;
          _this.err_message = '';
        }
        return result;
      }
    }
  },
  beforeDestroy() {
    if (this.sms.times != null) {
      clearInterval(this.sms.times);
      this.sms.times = null;
    }
  },
  destroyed() {}
};
</script>
<style scoped lang="scss">
.sms-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .sms-box-title {
    width: 100%;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    line-height: 79px;
    height: 70px;
  }
  .form-item {
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: px2rem(64.9); // 5.9vw * 11
    height: px2rem(134.75); // 12.25vw * 11
    background-size: cover;
    border-radius: px2rem(28.875); // 2.625vw * 11
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    border: 2px solid #8c8c8c;
    position: relative;
    .login-input {
      flex: 1;
      height: 100%;
      padding: 0px;
    }
    .item-icon {
      height: 100%;
      width: px2rem(130);
      background-color: #fff;
      background-repeat: no-repeat;
      background-size: px2rem(90) px2rem(90);
      background-position: center;
    }
    .item-icon-phone {
      background-image: url('~@/assets/shoujihao.png');
    }
    .item-icon-verify {
      background-image: url('~@/assets/yaoshi.png');
    }
  }
  .login-btn {
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #306ace;
    padding: 0px !important;
    font-weight: 550;
    font-size: px2rem(48.125); // 4.375vw * 11
    letter-spacing: 1px; // 1px * 11
    margin-top: 0.5rem;
    border: none;
    margin-bottom: 0;
    border-radius: px2rem(28.875); // 2.625vw * 11
    height: px2rem(134.75); // 12.25vw * 11
  }
  .verify-btn {
    color: #fff;
    background-color: #2668c4;
    border-radius: 9px;
    height: px2rem(134.75);
    position: absolute;
    top: -1px;
    right: -3px;
  }
  .errorStyle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 2;
    height: px2rem(70);

    .errorStyle-text {
      color: rgb(152, 25, 25);
      font-size: px2rem(38);
      text-align: center;
      background-size: cover;
      // width: px2rem(578);
      width: 100%;
      height: px2rem(70);
      line-height: px2rem(70);
      // background: linear-gradient(to right, rgba(64, 122, 230, 0.1) 0%, rgba(64, 122, 230, 0.8) 50%, rgba(64, 122, 230, 0.1) 100%);
      // box-shadow: 0px 2px 4px 0px #09265926;
      // border-radius: 17%;
      border-radius: 11px;
    }
  }
}
</style>
